import { THarvest } from './types/Harvest';

function harvestVariety(harvest: Pick<THarvest, 'variety'>): string {
	return harvest.variety || '-';
}

export default harvestVariety;
